import type { RouteRecordRaw } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';

import spartenConfigModules from '@/features/Sparten';
import { guards } from '@/router/guards';
import { createSpartenRoutes } from '@/router/spartenRoutesFactory';
import {
  SESSION_STATUS,
  useSessionModal,
} from '@/utils/useSessionModal/useSessionModal';

const routes: Array<RouteRecordRaw> = [
  // catch all
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/404.vue'),
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/ErrorPage.vue'),
  },
  // login view
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Loading/index.vue'),
  },

  // create all sparten routes via factory function(s)
  ...createSpartenRoutes(spartenConfigModules),
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

router.afterEach(guards.afterEachGuard);
router.beforeEach(guards.beforeEach);

router.onError((error: Error) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Failed to load module script')
  ) {
    const { sessionStatus, open } = useSessionModal();
    if (sessionStatus.value !== SESSION_STATUS.NEW_VERSION_DEPLOYED) {
      open(SESSION_STATUS.NEW_VERSION_DEPLOYED);
    }
  }
});

export default router;
